module.exports = __webpack_public_path__ + "img/Menu_on.c7cf9970.svg";